import React, { useState, useEffect } from 'react';

import { getRequest } from 'utils/api';
import Matches from './Matches';

const PerfectMatchList = ({ updateFollowingList }) => {
  const [perfectMatchList, setPerfectMatchList] = useState([]);
  const [hasMorePerfectMatches, setHasMorePerfectMatches] = useState(false);
  const [featuredMatchList, setFeaturedMatchList] = useState([]);
  const [isLoading, setIsLoading] = useState({ perfectMatches: false, featuredMatches: false });

  const updatePerfectMatchGig = gig => {
    setPerfectMatchList(prevState => prevState.map(g => (g.id === gig.id ? gig : g)));

    updateFollowingList(gig);
  };

  useEffect(() => {
    let isMounted = true;
    setIsLoading(prevState => ({ ...prevState, featuredMatches: true }));
    getRequest({
      endpoint: 'gigs/featured',
      query: { per_page: 5 },
      resolveResponse: true,
    })
      .then(response => {
        const data = response.status === 204 ? [] : [...response.data.gigs];

        if (!isMounted) return;
        setFeaturedMatchList(data);
        setIsLoading(prevState => ({ ...prevState, featuredMatches: false }));
      })
      .catch(() => setIsLoading(prevState => ({ ...prevState, featuredMatches: false })));

    return () => (isMounted = false);
  }, []);

  useEffect(() => {
    setIsLoading(prevState => ({ ...prevState, perfectMatches: true }));

    getRequest({
      endpoint: 'gigs/best_matches',
      query: { per_page: 5 },
      resolveResponse: true,
    })
      .then(response => {
        const data = response.status === 204 ? [] : [...response.data.gigs];
        const count = response.headers['pagination-total-count'] || 0;

        setHasMorePerfectMatches(+count > 5);
        setPerfectMatchList(data);
        setIsLoading(prevState => ({ ...prevState, perfectMatches: false }));
      })
      .catch(() => setIsLoading(prevState => ({ ...prevState, perfectMatches: false })));

    return () => setIsLoading(prevState => ({ ...prevState, perfectMatches: false }));
  }, []);

  if (!isLoading.perfectMatches && perfectMatchList.length === 0) return null;

  return (
    <Matches
      gigs={perfectMatchList}
      updateGig={updatePerfectMatchGig}
      title="Perfect Match"
      link="discover/perfect-matches"
      hasMore={hasMorePerfectMatches}
      isLoading={isLoading.perfectMatches}
      isPerfectMatch={!isLoading.featuredMatches && featuredMatchList.length === 0}
    />
  );
};

export default PerfectMatchList;
